import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Button } from '@lmc/ui-kit'
import { Button as AntdButton, Dropdown, Menu, Modal } from 'antd'
import type React from 'react'
import { ThreeDots } from '../../../general/Icon/customShapes/ThreeDots'
import style from './ManageDeviceCell.module.less'

const { confirm } = Modal

type ModalType = 'warning' | 'danger'
export interface ManageDeviceCellProps {
  modalType: 'warning' | 'danger'
  handleModal?: (type: ModalType) => void
  isApproved?: boolean
  deviceId?: string
  callback?: () => void
}

export const showConfirm = (
  type: ModalType,
  showModal: boolean,
  deviceId: string,
  callback: (() => void) | undefined
) =>
  showModal
    ? confirm({
        title: 'Delete this device',
        icon: (
          <ExclamationCircleOutlined
            className={type === 'danger' ? style.iconDanger : style.iconWarning}
          />
        ),
        content: 'This is a trusted device, are you sure?',
        onOk() {
          removeDevice(deviceId, callback)
        }
      })
    : approveDevice(deviceId, callback)

export const approveDevice = (
  deviceId: string,
  callback: (() => void) | undefined
) => {
  fetch(`/api/list/devices/${deviceId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ isApproved: true })
  })
    .then((response) => response.json())
    .then(() => {
      callback?.()
    })
}

export const removeDevice = (
  deviceId: string,
  callback: (() => void) | undefined
) => {
  fetch(`/api/list/devices/${deviceId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then((response) => response.json())
    .then(() => {
      callback?.()
    })
}

const DropdownMenu: React.FC<
  Pick<ManageDeviceCellProps, 'deviceId' | 'callback'>
> = ({ deviceId, callback }) => (
  <Menu>
    <Menu.Item
      onClick={() => {
        // @ts-ignore
        showConfirm('danger', true, deviceId, callback)
      }}
    >
      REMOVE DEVICE
    </Menu.Item>
  </Menu>
)

export const ManageDeviceCell: React.FC<ManageDeviceCellProps> = ({
  modalType,
  handleModal = showConfirm,
  isApproved,
  deviceId,
  callback
}) =>
  !isApproved ? (
    <Button
      variant="primary"
      onClick={() => {
        // @ts-ignore
        handleModal(modalType, false, deviceId, callback)
      }}
    >
      APPROVE
    </Button>
  ) : (
    <Dropdown
      overlay={<DropdownMenu deviceId={deviceId} callback={callback} />}
      placement="bottomRight"
    >
      <AntdButton className={style.button}>
        <ThreeDots />
      </AntdButton>
    </Dropdown>
  )
